import { useState, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_SMART_DOCS_FILTERS, GET_SMART_DOCS_SETUP } from '../../../../../utils/GraphQLAPI'
import DocumentSetup from '../smartDocsSetUp/smartDocsSetUp'
import SmartDocsList from '../SmartDocsMainPage/smartDocsList'

const SmartDocs = () => {
  const [editedData, setEditedData] = useState<any>([])

  const [getsSmartDocsFilterAndSetUp, { data }] = useLazyQuery(GET_SMART_DOCS_FILTERS, {
    onCompleted: (resData) => {
      console.log('resData', resData)
    },
    fetchPolicy: "network-only"
  })
  const [getSmartDocsSetUp, { loading: setUpLoading, data: SetUp }] = useLazyQuery(GET_SMART_DOCS_SETUP, {
    onCompleted: (resData) => {
      setLocalData(resData)
    },
    fetchPolicy: "network-only"
  })
  const setLocalData = (fetchData: any) => {
    const fetchedItems: any = []
    fetchData?.getAllInputValuesAtDocCreation?.forEach((item: any) => {
      if (item?.constructedInputs?.enum !== "UTILITY") {
        item.names.forEach((objData: any) =>
          fetchedItems.push({
            ...objData,
            enum: item.enum,
            isNew: false,       // Existing items
            isModified: false   // Not modified yet
          })
        )
      }
    })
    setEditedData(fetchedItems)
  }
  useEffect(() => {
    getsSmartDocsFilterAndSetUp()
    getSmartDocsSetUp()
  }, [])


  return (
    <>
      <div className='d-flex flex-row justify-content-between align-items-center mb-5'>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>SmartDocs</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - SmartDocs</span>
        </div>
        <div>
          <DocumentSetup getsSmartDocsFilterAndSetUp={getSmartDocsSetUp}
            editedData={editedData}
            getProductSetup={getSmartDocsSetUp}
            loading={setUpLoading}
            data={SetUp}
            setEditedData={setEditedData}
            featureFlags={true} />
        </div>
      </div>
      <SmartDocsList filterData={data} SetUp={SetUp?.getSmartDocDetailsByClientId?.fontAppearance?.fontSize} />
    </>
  )
}

export default SmartDocs
